<ion-button
  [attr.aria-label]="label"
  [class]="class"
  [ngClass]="{
    disabled: disabled
  }"
  [color]="color"
  [disabled]="disabled"
  (click)="handleClick()"
>
  <div class="button-content" [attr.title]="label ? label : null">
    <fa-icon
      *ngIf="icon"
      [icon]="icon"
      [spin]="animated"
      [pulse]="animated"
    ></fa-icon>
    <ion-text>
      <ng-content></ng-content>
    </ion-text>
  </div>
</ion-button>
